import { IgnorableNetworkError } from '@/Factories/BookingkitApi/Errors/IgnorableNetworkError';
export class RequestAbortedError extends IgnorableNetworkError {
    constructor(...params: any) {
        super(...params);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RequestAbortedError);
        }
        this.name = 'RequestAbortedError';
    }

    static fromRequestAbortedRequest(e: any):RequestAbortedError {
        return new RequestAbortedError('This request was aborted', e);
    }
}

export default { RequestAbortedError };
